import { render } from "./ItemCarrinho.vue?vue&type=template&id=320c1ffc&scoped=true"
import script from "./ItemCarrinho.vue?vue&type=script&lang=js"
export * from "./ItemCarrinho.vue?vue&type=script&lang=js"

import "./ItemCarrinho.vue?vue&type=style&index=0&id=320c1ffc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320c1ffc"]])

export default __exports__